import { Button, Modal, ModalBody, ModalHeader } from '@change/ds-core-ui';

import { TranslatePlural, useI18n } from '@change-corgi/core/react/i18n';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { DecisionMakerCard } from '../DecisionMakerCard';
import { LegislativeBodyCard } from '../LegislativeBodyCard';

import { useViewAll } from './hooks/useViewAll';

export const ViewAll: React.FC<{ totalDmCount: number }> = ({ totalDmCount }) => {
	const {
		data: { dmsAndLBs, petitionAsk, loading },
		actions: { handleViewAllClick },
	} = useViewAll();

	const { translate } = useI18n();

	return (
		<Modal
			size="large"
			onClose={() => {}}
			trigger={
				<div className="w-full text-center">
					<Button data-qa="legislative-bodies-show-all" className="w-full" onClick={handleViewAllClick}>
						<TranslatePlural
							value="corgi.petition_gamma.decision_makers_v2.view_all.trigger"
							replacements={{ numberOfDms: totalDmCount }}
							count={totalDmCount}
						/>
					</Button>
				</div>
			}
			className="z-[5000] lg:[&_*]:!col-span-full"
			data-qa="all-decision-makers-modal"
		>
			<ModalHeader title={translate('corgi.petition_gamma.decision_makers_v2.view_all.title')} subtitle={petitionAsk} />
			<ModalBody className="!max-h-none">
				{loading ? (
					<div className="m-auto" data-testid="loader">
						<Loader />
					</div>
				) : (
					<div className="flex flex-col gap-6">
						{dmsAndLBs.map((body) =>
							body.type === 'single' ? (
								<DecisionMakerCard key={body.displayedDMs[0].id} dm={body.displayedDMs[0]} />
							) : (
								<LegislativeBodyCard key={body.title} legislativeBody={body} />
							),
						)}
					</div>
				)}
			</ModalBody>
		</Modal>
	);
};
